export enum TransactionApprovalType {
  APPROVE = 'APPROVE',
  REPROVE = 'REPROVE',
}

export enum TransactionRequestStatus {
  PENDING = 1,
  EXECUTED = 2,
  FAILED = 3,
  PENDING_APPROVE = 4,
  REPROVED = 5,
  EXPIRED = 6,
  SCHEDULE = 7,
  CANCELLED = 8,
  REPROVED_BY_ANTIFRAUD = 9,
}

export enum TransactionStatus {
  PENDING_CONFIRM = 1,
  EXECUTED = 2,
  FAILED = 3,
  REVERSAL = 4,
  REPROVED = 5,
  PENDING_CREATE = 6,
  EXPIRED = 7,
  SCHEDULE = 8,
  CANCELLED = 9,
  TARIFF_NOT_PAID = 10,
  PENDING_APPROVE = 33,
  PENDING_CORE_BANK = 34,
  REPROVED_BY_ANTIFRAUD = 40,
}

export enum TransactionRequestPendingApprovalStatus {
  PENDING = 1,
  APPROVED = 2,
  REPROVED = 3,
}
